(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[332,587],{

/***/ 2697:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schedule",
      function () {
        return __webpack_require__(1934);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6492);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(594);
/* harmony import */ var _context_UIContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6849);
/* harmony import */ var _JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9373);
/* harmony import */ var _JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Cta_Cta__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3499);










var JoinFlowInfoModal = function(param) {
    var isOpen = param.isOpen, tmToken = param.tmToken, idTokenHint = param.idTokenHint;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,_context_UIContext__WEBPACK_IMPORTED_MODULE_3__/* .useUI */ .l)(), uiState = ref5.state, dispatch = ref5.dispatch;
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), checkIfEmailVerified = ref6[0], setCheckIfEmailVerified = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), verifyEmailFlow = ref7[0], setVerifyEmailFlow = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), ygbActive = ref8[0], setYgbActive = ref8[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (verifyEmailFlow !== window.localStorage.getItem("verify_email_flow")) {
            setVerifyEmailFlow(window.localStorage.getItem("verify_email_flow"));
        }
        if (ygbActive !== window.localStorage.getItem("ygb_active")) {
            setYgbActive(window.localStorage.getItem("ygb_active"));
        }
    }, [
        uiState
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (uiState.joinFlowInfoModal.isOpen) {
            document.body.style.overflow = "hidden";
            document.body.style.position = "fixed";
            document.body.style.touchAction = "none";
            document.body.style.width = "100%";
        } else {
            document.body.style.overflow = "auto";
            document.body.style.position = "static";
            document.body.style.touchAction = "";
            document.body.style.width = "unset";
        }
    }, [
        isOpen
    ]);
    var ref9 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__/* .useQuery */ .a)({
        queryKey: [
            "verify_email"
        ],
        queryFn: function() {
            return axios__WEBPACK_IMPORTED_MODULE_2___default().get("/api/tm-auth/verify-email", {
                params: {
                    access_token: tmToken
                }
            });
        },
        enabled: false,
        onSuccess: function() {
            setCheckIfEmailVerified(true);
        }
    }), data = ref9.data, sendVerifyEmailRequest = ref9.refetch;
    (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__/* .useQuery */ .a)({
        queryKey: [
            "check_verified_email"
        ],
        queryFn: function() {
            return axios__WEBPACK_IMPORTED_MODULE_2___default().get("/api/tm-auth/check-email", {
                params: {
                    access_token: tmToken
                }
            });
        },
        enabled: checkIfEmailVerified,
        refetchInterval: checkIfEmailVerified ? 5000 : false,
        onSuccess: function(aData) {
            if (aData.data.data.me.profile.emailConfirmed) {
                setCheckIfEmailVerified(false);
                dispatch({
                    type: "confirmEmail"
                });
                dispatch({
                    type: "openSignupModal"
                });
            }
        }
    });
    if (!isOpen) return null;
    var origin =  true && window.location.origin ? window.location.origin : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8___default().joinFlowInfoModal),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8___default().joinFlowInfoModalContentWrapper),
            children: [
                (uiState.joinFlowInfoModal.modalType === "signup" || uiState.joinFlowInfoModal.modalType === "email" && !data) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    className: (_JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8___default().closeIcon),
                    style: {
                        fontSize: 26
                    },
                    onClick: function() {
                        if (verifyEmailFlow === "true") {
                            window.localStorage.setItem("verify_email_flow", "false");
                        }
                        if (ygbActive === "true") {
                            window.localStorage.setItem("ygb_active", "false");
                        }
                        window.localStorage.setItem("next_signup_uri", "");
                        if (uiState.joinFlowInfoModal.modalType === "email" && !!tmToken) {
                            router.push("https://login.trackmanrange.com/connect/endsession?id_token_hint=".concat(idTokenHint, "&post_logout_redirect_uri=").concat(origin));
                        }
                        dispatch({
                            type: "toggleJoinFlowInfoModal",
                            payload: {
                                isOpen: false
                            }
                        });
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8___default().joinFlowInfoModalContent),
                    children: [
                        uiState.joinFlowInfoModal.modalType === "signup" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                uiState.joinFlowInfoModal.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: uiState.joinFlowInfoModal.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "To join the tournament, please log in with your Trackman account or sign up for a new one."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Cta_Cta__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    className: (_JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8___default().cta),
                                    name: "Go to login",
                                    onClick: function() {
                                        window.localStorage.setItem("ygb_active", "true");
                                        (0,next_auth_react__WEBPACK_IMPORTED_MODULE_4__.signIn)("trackman");
                                    }
                                })
                            ]
                        }),
                        uiState.joinFlowInfoModal.modalType === "email" && !data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "To sign up for the tournament, you must first verify your email address."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Cta_Cta__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    className: (_JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8___default().cta),
                                    name: "Verify email",
                                    onClick: function() {
                                        return sendVerifyEmailRequest();
                                    }
                                })
                            ]
                        }),
                        uiState.joinFlowInfoModal.modalType === "email" && (data === null || data === void 0 ? void 0 : data.status) === 200 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        "Verification email sent to",
                                        "".concat((data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.me) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.profile) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.sendEmailConfirmation) === null || ref4 === void 0 ? void 0 : ref4.email) ? " " + data.data.data.me.profile.sendEmailConfirmation.email : " your trackman email address"),
                                        ". Check your inbox and follow the instructions."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Once confirmed, you'll be redirected to the next step. To stop sign up, click the button below."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Cta_Cta__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    className: (_JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8___default().cta),
                                    name: "Close",
                                    onClick: function() {
                                        window.localStorage.setItem("verify_email_flow", "false");
                                        window.localStorage.setItem("ygb_active", "false");
                                        window.localStorage.setItem("next_signup_uri", "");
                                        dispatch({
                                            type: "toggleJoinFlowInfoModal",
                                            payload: {
                                                isOpen: false
                                            }
                                        });
                                        router.push("https://login.trackmanrange.com/connect/endsession?id_token_hint=".concat(idTokenHint, "&post_logout_redirect_uri=").concat(origin));
                                    }
                                })
                            ]
                        }),
                        uiState.joinFlowInfoModal.modalType === "email" && data && data.status !== 200 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Ooops... something went wrong. Please try again"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Cta_Cta__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    className: (_JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8___default().cta),
                                    name: "Close",
                                    onClick: function() {
                                        window.localStorage.setItem("verify_email_flow", "false");
                                        window.localStorage.setItem("ygb_active", "false");
                                        window.localStorage.setItem("next_signup_uri", "");
                                        dispatch({
                                            type: "toggleJoinFlowInfoModal",
                                            payload: {
                                                isOpen: false
                                            }
                                        });
                                    }
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (JoinFlowInfoModal);


/***/ }),

/***/ 4139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Schedule_Schedule; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/GridElement/index.ts
var GridElement = __webpack_require__(5299);
// EXTERNAL MODULE: ./components/GridWrapper/index.ts
var GridWrapper = __webpack_require__(2409);
// EXTERNAL MODULE: ./components/Schedule/Schedule.module.css
var Schedule_module = __webpack_require__(5766);
var Schedule_module_default = /*#__PURE__*/__webpack_require__.n(Schedule_module);
// EXTERNAL MODULE: ./components/ScheduleList/ScheduleList.tsx
var ScheduleList = __webpack_require__(1569);
;// CONCATENATED MODULE: ./components/Schedule/Schedule.tsx





var Schedule = function(param) {
    var firstSeasonTournaments = param.firstSeasonTournaments, secondSeasonTournaments = param.secondSeasonTournaments, thirdSeasonTournaments = param.thirdSeasonTournaments;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GridWrapper/* default */.Z, {
        className: (Schedule_module_default()).scheduleGridWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridElement/* default */.Z, {
            gridLayout: [
                [
                    1401,
                    5,
                    24
                ]
            ],
            children: ((firstSeasonTournaments === null || firstSeasonTournaments === void 0 ? void 0 : firstSeasonTournaments.length) > 0 || (secondSeasonTournaments === null || secondSeasonTournaments === void 0 ? void 0 : secondSeasonTournaments.length) > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduleList/* default */.Z, {
                    firstSeasonTournaments: firstSeasonTournaments,
                    secondSeasonTournaments: secondSeasonTournaments,
                    thirdSeasonTournaments: thirdSeasonTournaments
                })
            })
        })
    });
};
/* harmony default export */ var Schedule_Schedule = (Schedule);

;// CONCATENATED MODULE: ./components/Schedule/index.ts



/***/ }),

/***/ 5473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useTmSignOut; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _context_UIContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6849);



var useTmSignOut = function() {
    var ref = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.useSession)(), session = ref.data;
    var ref1 = (0,_context_UIContext__WEBPACK_IMPORTED_MODULE_2__/* .useUI */ .l)(), uiState = ref1.state;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ((session === null || session === void 0 ? void 0 : session.accessToken) && window.localStorage.getItem("ygb_active") === "false" && window.localStorage.getItem("verify_email_flow") === "false") {
            (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.signOut)({
                redirect: false
            });
        }
    }, [
        session,
        uiState
    ]);
};


/***/ }),

/***/ 1934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ SchedulePage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Schedule__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4139);
/* harmony import */ var _components_JoinFlowInfoModal_JoinFlowInfoModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7425);
/* harmony import */ var _hooks_useTmSignOut__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5473);
/* harmony import */ var _context_UIContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6849);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _storyblok_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9036);









var SchedulePageHead = function(param) {
    var seo = param.seo, isProd = param.isProd;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_7___default()), {
        children: [
            !isProd && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: seo === null || seo === void 0 ? void 0 : seo.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "initial-scale=1.0, width=device-width, maximum-scale=1.0, user-scalable=0"
            }, "viewport"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: seo === null || seo === void 0 ? void 0 : seo.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: seo === null || seo === void 0 ? void 0 : seo.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: seo === null || seo === void 0 ? void 0 : seo.og_title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: seo === null || seo === void 0 ? void 0 : seo.og_description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "/images/next_tournament_s3.jpg"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:title",
                content: seo === null || seo === void 0 ? void 0 : seo.twitter_title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: seo === null || seo === void 0 ? void 0 : seo.twitter_description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:image",
                content: "/images/next_tournament_s3.jpg"
            })
        ]
    });
};
var __N_SSG = true;
function SchedulePage(param) {
    var secondSeasonTournaments = param.secondSeasonTournaments, firstSeasonTournaments = param.firstSeasonTournaments, thirdSeasonTournaments = param.thirdSeasonTournaments, upcomingTournaments = param.upcomingTournaments, isProd = param.isProd, story = param.story;
    var ref, ref1, ref2;
    story = (0,_storyblok_react__WEBPACK_IMPORTED_MODULE_8__/* .useStoryblokState */ .f0)(story);
    var ref3 = (0,_context_UIContext__WEBPACK_IMPORTED_MODULE_4__/* .useUI */ .l)(), uiState = ref3.state;
    var ref4 = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_5__.useSession)(), session = ref4.data;
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""), verifyEmailFlow = ref5[0], setVerifyEmailFlow = ref5[1];
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (verifyEmailFlow !== window.localStorage.getItem("verify_email_flow")) {
            setVerifyEmailFlow(window.localStorage.getItem("verify_email_flow"));
        }
    }, [
        uiState
    ]);
    (0,_hooks_useTmSignOut__WEBPACK_IMPORTED_MODULE_3__/* .useTmSignOut */ .y)();
    var scheduleCards = upcomingTournaments === null || upcomingTournaments === void 0 ? void 0 : upcomingTournaments.filter(function(tournament) {
        var ref;
        return (tournament === null || tournament === void 0 ? void 0 : (ref = tournament.versionInfo) === null || ref === void 0 ? void 0 : ref.state) !== "DRAFT";
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SchedulePageHead, {
                seo: story === null || story === void 0 ? void 0 : (ref = story.content) === null || ref === void 0 ? void 0 : ref.seo,
                isProd: isProd
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_JoinFlowInfoModal_JoinFlowInfoModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                isOpen: uiState.joinFlowInfoModal.isOpen && ((session === null || session === void 0 ? void 0 : session.accessToken) && !uiState.isEmailVerified && verifyEmailFlow === "true" && uiState.joinFlowInfoModal.modalType === "email" || uiState.joinFlowInfoModal.modalType === "signup"),
                tmToken: session === null || session === void 0 ? void 0 : session.accessToken,
                idTokenHint: session === null || session === void 0 ? void 0 : session.idToken
            }),
            story === null || story === void 0 ? void 0 : (ref1 = story.content) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.body) === null || ref2 === void 0 ? void 0 : ref2.map(function(c) {
                if (c.component === "tournament_card_overview") {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storyblok_react__WEBPACK_IMPORTED_MODULE_8__/* .StoryblokComponent */ .Xj, {
                        blok: c,
                        tournaments: scheduleCards
                    }, c._uid);
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storyblok_react__WEBPACK_IMPORTED_MODULE_8__/* .StoryblokComponent */ .Xj, {
                    blok: c
                }, c._uid);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Schedule__WEBPACK_IMPORTED_MODULE_1__["default"], {
                firstSeasonTournaments: firstSeasonTournaments,
                secondSeasonTournaments: secondSeasonTournaments,
                thirdSeasonTournaments: thirdSeasonTournaments
            })
        ]
    });
}


/***/ }),

/***/ 9373:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"joinFlowInfoModal":"JoinFlowInfoModal_joinFlowInfoModal__zEgHB","joinFlowInfoModalContentWrapper":"JoinFlowInfoModal_joinFlowInfoModalContentWrapper__E8Ymp","closeIcon":"JoinFlowInfoModal_closeIcon__g1LQB","joinFlowInfoModalContent":"JoinFlowInfoModal_joinFlowInfoModalContent__ZNfdO","cta":"JoinFlowInfoModal_cta__g533Z"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [678,885,260,774,888,179], function() { return __webpack_exec__(2697); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);